<template>
    <div class="container-fluid delivery-container">
        <div class="card mt-5">
            <div class="card-body">
                <!-- Start Delivery Toggle -->
                <div class="text-center mb-4">
                    <div class="d-inline-flex align-items-center">
                        <span class="mr-3">¿Empezó entrega?</span>
                        <el-switch
                            v-model="deliverActive"
                            :disabled="deliverActive"
                            @change="start_serve()"
                            active-color="#28a745"
                            inactive-color="#ccc"
                        ></el-switch>
                        <span v-if="deliverActive" class="badge badge-success ml-3">
                            <i class="fas fa-check-circle"></i> Activo
                        </span>
                    </div>
                </div>

                <!-- Routes Table -->
                <div class="table-responsive" :style="{ filter: !deliverActive ? 'blur(3px)' : 'none' }">
                    <table class="table table-striped table-hover">
                        <thead class="bg-success text-white">
                        <tr>
                            <th>Ruta</th>
                            <th>Hora</th>
                            <th>Ruta Lista</th>
                            <th>Ruta Entregada</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in meals" :key="index">
                            <td>
                                <button
                                    @click="showDeliverModal(item)"
                                    class="btn btn-sm btn-warning"
                                    :disabled="!deliverActive"
                                >
                                    {{ item.name }}
                                </button>
                            </td>
                            <td>{{ item.hour ? item.hour.substr(0, 5) : '-' }}</td>

                            <!-- Ruta Lista Toggle -->
                            <td class="text-center">
                                <el-switch
                                    v-if="getItemByLabelId(item.route_id, 1)"
                                    :value="Boolean(getItemByLabelId(item.route_id, 1).status)"
                                    :disabled="!deliverActive || disabledCheck"
                                    @change="checkClick(getItemByLabelId(item.route_id, 1))"
                                ></el-switch>
                            </td>

                            <!-- Ruta Entregada Toggle -->
                            <td class="text-center">
                                <el-switch
                                    v-if="getItemByLabelId(item.route_id, 2)"
                                    :value="Boolean(getItemByLabelId(item.route_id, 2).status)"
                                    :disabled="!deliverActive || disabledCheck"
                                    @change="checkClick(getItemByLabelId(item.route_id, 2))"
                                ></el-switch>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Finish Turn Button -->
                <div class="text-center mt-4">
                    <button
                        :disabled="finishTurn || !deliverActive || turnFinished"
                        class="btn btn-lg"
                        :class="turnFinished ? 'btn-secondary' : 'btn-success'"
                        @click="showFinishModal"
                    >
                        {{ turnFinished ? '✓ Turno Finalizado' : 'Finalizar Turno' }}
                    </button>
                </div>
            </div>
        </div>

        <!-- Modal: Reconsumar Item -->
        <el-dialog
            :visible.sync="showReconsumeModal"
            title="Verificación"
            width="500px"
        >
            <div v-if="tempModalVar">
                <div class="form-group">
                    <div class="d-flex align-items-center mb-3">
                        <label class="mb-0 mr-3"><strong>{{ tempModalVar.label_name }}</strong></label>
                        <el-switch v-model="tempModalVar.status"></el-switch>
                    </div>
                    <label>Comentario</label>
                    <textarea
                        class="form-control"
                        placeholder="Comentario"
                        v-model="tempModalVar.comment"
                        rows="4"
                    ></textarea>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button class="btn btn-secondary" @click="showReconsumeModal = false">Cancelar</button>
                <button class="btn btn-success" @click="saveCheck(tempModalVar)">Guardar</button>
            </span>
        </el-dialog>

        <!-- Modal: Repartidor Info -->
        <el-dialog
            :visible.sync="RepartidorModal"
            title="Datos del Repartidor"
            width="500px"
        >
            <div v-if="VarTempDeliver" class="repartidor-data">
                <p><strong>Ruta:</strong> {{ VarTempDeliver.name }}</p>
                <p><strong>Repartidor:</strong> {{ VarTempDeliver.dealer_name }}</p>
                <p>
                    <strong>Teléfono:</strong>
                    <a :href="'tel:' + VarTempDeliver.dealer_phone" target="_blank">
                        {{ VarTempDeliver.dealer_phone }}
                    </a>
                </p>
                <p>
                    <strong>WhatsApp:</strong>
                    <a :href="'https://wa.me/' + VarTempDeliver.dealer_phone.replace('+', '')" target="_blank">
                        {{ VarTempDeliver.dealer_phone }}
                    </a>
                </p>
            </div>
            <span slot="footer" class="dialog-footer">
                <button class="btn btn-success" @click="RepartidorModal = false">Cerrar</button>
            </span>
        </el-dialog>

        <!-- Modal: Finish Turn Feedback -->
        <el-dialog
            :visible.sync="FinishModal"
            :title="'Finalizar Turno - ' + new Date().toLocaleDateString()"
            width="90%"
        >
            <div v-if="servedMeals" class="table-responsive">
                <table class="table table-striped">
                    <thead class="bg-light">
                    <tr>
                        <th>Alimento</th>
                        <th colspan="2">¿Tuviste problemas con esta receta?</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, key) in servedMeals" :key="item.id">
                        <td><strong>{{ item.name }}</strong></td>
                        <td>
                            <div class="form-check form-check-inline">
                                <input
                                    type="radio"
                                    :id="'check-yes-' + key"
                                    :name="'check-' + key"
                                    class="form-check-input"
                                    value="1"
                                    v-model="checklistFinish[key]"
                                    required
                                />
                                <label class="form-check-label" :for="'check-yes-' + key">Sí</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input
                                    type="radio"
                                    :id="'check-no-' + key"
                                    :name="'check-' + key"
                                    class="form-check-input"
                                    value="0"
                                    v-model="checklistFinish[key]"
                                />
                                <label class="form-check-label" :for="'check-no-' + key">No</label>
                            </div>
                        </td>
                        <td>
                            <textarea
                                class="form-control"
                                :disabled="checklistFinish[key] == 0"
                                v-model="checkcommentsFinish[key]"
                                rows="3"
                                :required="checklistFinish[key] == 1"
                                placeholder="Describe el problema..."
                            ></textarea>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
                <button class="btn btn-secondary" @click="FinishModal = false">Cancelar</button>
                <button class="btn btn-success" @click="saveFinish()">Guardar</button>
            </span>
        </el-dialog>

        <!-- Modal: Success (commented - using inline message instead) -->
        <!-- <el-dialog
            :visible.sync="SuccessModal"
            title="Éxito"
            width="400px"
        >
            <div class="text-center py-5">
                <div class="mb-4">
                    <i class="fas fa-check-circle text-success" style="font-size: 4rem;"></i>
                </div>
                <h4 class="mb-4">Guardado con éxito</h4>
                <p>El turno ha sido finalizado correctamente.</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <button class="btn btn-success" @click="SuccessModal = false">Regresar a Inicio</button>
            </span>
        </el-dialog> -->
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'Delivery',
    data() {
        return {
            disabledCheck: false,
            meals: [],
            servedMeals: null,
            showReconsumeModal: false,
            tempModalVar: null,
            VarTempDeliver: null,
            RepartidorModal: false,
            FinishModal: false,
            checklistFinish: {},
            checkcommentsFinish: {},
            feedback: [],
            deliverActive: false,
            deliverActiveByRoute: {},
            initialLoad: false,
            turnFinished: false,
        };
    },
    created() {
        if (!this.initialLoad) {
            this.initialLoad = true;
            Promise.all([
                this.getRoutes(),
                this.getMenus()
            ]);
        }
    },
    computed: {
        finishTurn() {
            if (this.meals && this.meals.length > 0) {
                return this.meals.some(item => {
                    const item_delivered = this.getItemByLabelId(item.route_id, 2);
                    return !item_delivered || !Boolean(item_delivered.status);
                });
            }
            return false;
        }
    },
    methods: {
        getItemByLabelId(route_id, label_id) {
            if (this.deliverActiveByRoute[route_id]) {
                const item = this.deliverActiveByRoute[route_id].find(
                    item => item.items_route_label_id == label_id
                );
                return item || null;
            }
            return null;
        },
        showDeliverModal(item) {
            this.VarTempDeliver = item;
            this.RepartidorModal = true;
        },
        showFinishModal() {
            if (this.finishTurn) {
                this.$message.warning('Marca todas las rutas como entregadas');
                return;
            }
            // Initialize all checklist items with "No" (0) by default
            if (this.servedMeals && this.servedMeals.length > 0) {
                this.servedMeals.forEach((meal, index) => {
                    if (!this.checklistFinish.hasOwnProperty(index)) {
                        this.$set(this.checklistFinish, index, '0');
                    }
                });
            }
            this.FinishModal = true;
        },
        getRoutes() {
            this.disabledCheck = true;
            return axios
                .get('/deliver/getRoutes')
                .then(response => {
                    if (response.data.deliverActive && response.data.deliverActive.length >= 1) {
                        this.meals = response.data.deliverActive;
                        this.deliverActiveByRoute = response.data.deliverActiveByRoute;
                    } else {
                        this.meals = [];
                    }
                    if (response.data.deliveryStarted) {
                        this.deliverActive = true;
                    } else {
                        this.deliverActive = false;
                    }
                    // Get turn finished status from server
                    if (response.data.turnFinished) {
                        this.turnFinished = true;
                    } else {
                        this.turnFinished = false;
                    }
                    this.disabledCheck = false;
                })
                .catch(error => {
                    this.$message.error('Error al cargar rutas');
                    console.error(error);
                    this.disabledCheck = false;
                });
        },
        start_serve() {
            if (!this.deliverActive) {
                this.deliverActive = false;
                return;
            }

            axios
                .post('/deliver/start', { meals: this.meals })
                .then(response => {
                    if (response.data.deliveryStarted) {
                        this.$message.success('Entrega iniciada');
                        this.getRoutes();
                    } else {
                        this.$message.error('Error al iniciar entrega');
                        this.deliverActive = false;
                    }
                })
                .catch(error => {
                    this.$message.error('Error al iniciar entrega');
                    this.deliverActive = false;
                    console.error(error);
                });
        },
        getMenus() {
            return axios
                .get('/serve/getMenu')
                .then(response => {
                    this.servedMeals = response.data.meals;
                })
                .catch(error => {
                    this.$message.error('Error al cargar menús');
                    console.error(error);
                });
        },
        checkClick(item) {
            if (!item) return;
            this.disabledCheck = true;
            this.showReconsumeModal = true;
            this.tempModalVar = { ...item };
            this.tempModalVar.status = !Boolean(this.tempModalVar.status);
        },
        saveCheck(tempModalVar) {
            this.disabledCheck = true;
            const payload = {
                checklist: {
                    ...tempModalVar,
                    status: tempModalVar.status ? 1 : 0
                }
            };
            axios
                .post('/deliver/save', payload)
                .then(() => {
                    this.$message.success('Cambio guardado');
                    this.showReconsumeModal = false;
                    this.disabledCheck = false;
                    this.getRoutes();
                    // TODO: Broadcast realtime event
                    // axios.post('/deliver/realtime', {
                    //     origin: 'checklist',
                    //     data: payload
                    // }).catch(() => {});
                })
                .catch(error => {
                    this.$message.error('Error al guardar');
                    this.disabledCheck = false;
                    console.error(error);
                });
        },
        saveFinish() {
            if (!this.servedMeals) {
                this.$message.error('No hay menús cargados');
                return;
            }

            if (Object.keys(this.checklistFinish).length !== this.servedMeals.length) {
                this.$message.error('Marca todas las recetas con sí o no');
                return;
            }

            this.feedback = [];
            this.servedMeals.forEach((meal, index) => {
                // Always send all meals: with comment if problem (status=1), empty if no problem (status=0)
                this.feedback.push({
                    meal_id: meal.id,
                    comment: this.checklistFinish[index] == 1 ? (this.checkcommentsFinish[index] || '') : ''
                });
            });

            axios.post('/deliver/finish', this.feedback)
                .then(() => {
                    this.$message.success('Turno finalizado correctamente');
                    this.checklistFinish = {};
                    this.checkcommentsFinish = {};
                    this.feedback = [];
                    this.FinishModal = false;
                    // Refresh to get updated turnFinished status from server
                    this.getRoutes();
                })
                .catch(error => {
                    this.$message.error('Error al finalizar turno');
                    console.error(error);
                });
        }
    }
};
</script>

<style scoped>
.delivery-container {
    padding: 20px 0;
    min-height: 100vh;
    background-color: #f5f5f5;
}

.card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.repartidor-data p {
    margin-bottom: 12px;
    font-size: 16px;
}

.repartidor-data a {
    color: #0066cc;
    text-decoration: none;
}

.repartidor-data a:hover {
    text-decoration: underline;
}

.table-hover tbody tr:hover {
    background-color: #f9f9f9;
}

.bg-success {
    background-color: #28a745 !important;
}

.text-danger {
    color: #dc3545;
}

.dialog-footer {
    text-align: right;
    padding-top: 12px;
}

@media (max-width: 768px) {
    .table-responsive {
        font-size: 0.85rem;
    }

    .btn-lg {
        padding: 0.75rem 1.5rem !important;
    }
}
</style>
